import React from "react";
import TenderPayment from "./TenderPayment";
import icon from "../../Assets/icon.png";
import projectOne from "./projectOne.png";

import { Link, useLocation } from "react-router-dom";

function ProjectSidebar() {
  const location = useLocation();
  const isActivePayment = location.pathname === "/payments";
  const isActiveProject01 = location.pathname === "/project01";
  const isActiveProject02 = location.pathname === "/project02";
  const isActiveProject03 = location.pathname === "/project03";

  return (
    <div className="side-class">
      <div className="sidebar">
        <div className="w-100 mb-5 text-start">
          <Link to={"/"}>
            <img src={icon} alt="icorpLogo" width={"70px"} />
          </Link>
        </div>
        <div className="sidebar-links">
          <ul>
            <li>
              <Link
                to="/payments"
                className={isActivePayment ? "nav_list  active" : "nav_list"}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M64 32C28.7 32 0 60.7 0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32zM576 224L0 224 0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-192zM112 352l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z" />
                </svg>

                <span className="sidebar-names">Project Payments</span>
              </Link>
            </li>
            <li>
              <Link
                to="/project01"
                className={isActiveProject01 ? "nav_list  active" : "nav_list"}
              >
                <svg
                  id="Layer_1"
                  enable-background="new 0 0 66 66"
                  viewBox="0 0 66 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="XMLID_731_">
                    <path
                      id="XMLID_749_"
                      d="m33 35c-4.6 0-8.3 3.7-8.3 8.3s3.7 8.3 8.3 8.3 8.3-3.7 8.3-8.3-3.7-8.3-8.3-8.3z"
                    />
                    <path
                      id="XMLID_750_"
                      d="m47.7 14.7h9l-13.1-13.1v9c0 2.3 1.9 4.1 4.1 4.1z"
                    />
                    <path
                      id="XMLID_753_"
                      d="m47.7 16.7c-3.4 0-6.1-2.7-6.1-6.1v-9.6h-29c-2.2 0-3.9 1.8-3.9 3.9v56.2c0 2.2 1.8 3.9 3.9 3.9h40.8c2.2 0 3.9-1.8 3.9-3.9v-44.4zm-32.2-5.5h15.9c.6 0 1 .4 1 1s-.4 1-1 1h-15.9c-.6 0-1-.4-1-1s.4-1 1-1zm33.4 33.8c0 .4-.3.8-.7 1l-3.3 1c-.2.7-.5 1.4-.9 2.2l1.6 3.1c.2.4.1.9-.2 1.2l-2.4 2.2c-.3.3-.8.4-1.2.2l-3.1-1.6c-.7.4-1.4.7-2.2.9l-1 3.3c-.1.4-.5.7-1 .7h-3.3c-.4 0-.8-.3-1-.7l-1-3.3c-.8-.2-1.5-.5-2.2-.9l-3.1 1.6c-.4.2-.9.1-1.2-.2l-2.4-2.4c-.3-.3-.4-.8-.2-1.2l1.6-3c-.4-.7-.7-1.4-.9-2.2l-3.3-1c-.4-.1-.7-.5-.7-1v-3.3c0-.4.3-.8.7-1l3.3-1c.2-.7.5-1.5.9-2.2l-1.6-3c-.2-.4-.1-.9.2-1.2l2.4-2.4c.3-.3.8-.4 1.2-.2l3.1 1.6c.7-.4 1.4-.7 2.2-.9l1-3.3c.1-.4.5-.7 1-.7h3.3c.4 0 .8.3 1 .7l1 3.3c.8.2 1.5.5 2.2.9l3.1-1.6c.4-.2.9-.1 1.2.2l2.4 2.4c.3.3.4.8.2 1.2l-1.6 3.1c.4.7.7 1.4.9 2.2l3.3 1c.4.1.7.5.7 1zm1.6-23.6h-35c-.6 0-1-.4-1-1s.4-1 1-1h35c.6 0 1 .4 1 1s-.4 1-1 1z"
                    />
                  </g>
                </svg>
                <span className="sidebar-names">Project 001</span>
              </Link>
            </li>
            <li>
              <Link
                to="/project02"
                className={isActiveProject02 ? "nav_list  active" : "nav_list"}
              >
                <svg
                  id="Layer_1"
                  enable-background="new 0 0 66 66"
                  viewBox="0 0 66 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="XMLID_731_">
                    <path
                      id="XMLID_749_"
                      d="m33 35c-4.6 0-8.3 3.7-8.3 8.3s3.7 8.3 8.3 8.3 8.3-3.7 8.3-8.3-3.7-8.3-8.3-8.3z"
                    />
                    <path
                      id="XMLID_750_"
                      d="m47.7 14.7h9l-13.1-13.1v9c0 2.3 1.9 4.1 4.1 4.1z"
                    />
                    <path
                      id="XMLID_753_"
                      d="m47.7 16.7c-3.4 0-6.1-2.7-6.1-6.1v-9.6h-29c-2.2 0-3.9 1.8-3.9 3.9v56.2c0 2.2 1.8 3.9 3.9 3.9h40.8c2.2 0 3.9-1.8 3.9-3.9v-44.4zm-32.2-5.5h15.9c.6 0 1 .4 1 1s-.4 1-1 1h-15.9c-.6 0-1-.4-1-1s.4-1 1-1zm33.4 33.8c0 .4-.3.8-.7 1l-3.3 1c-.2.7-.5 1.4-.9 2.2l1.6 3.1c.2.4.1.9-.2 1.2l-2.4 2.2c-.3.3-.8.4-1.2.2l-3.1-1.6c-.7.4-1.4.7-2.2.9l-1 3.3c-.1.4-.5.7-1 .7h-3.3c-.4 0-.8-.3-1-.7l-1-3.3c-.8-.2-1.5-.5-2.2-.9l-3.1 1.6c-.4.2-.9.1-1.2-.2l-2.4-2.4c-.3-.3-.4-.8-.2-1.2l1.6-3c-.4-.7-.7-1.4-.9-2.2l-3.3-1c-.4-.1-.7-.5-.7-1v-3.3c0-.4.3-.8.7-1l3.3-1c.2-.7.5-1.5.9-2.2l-1.6-3c-.2-.4-.1-.9.2-1.2l2.4-2.4c.3-.3.8-.4 1.2-.2l3.1 1.6c.7-.4 1.4-.7 2.2-.9l1-3.3c.1-.4.5-.7 1-.7h3.3c.4 0 .8.3 1 .7l1 3.3c.8.2 1.5.5 2.2.9l3.1-1.6c.4-.2.9-.1 1.2.2l2.4 2.4c.3.3.4.8.2 1.2l-1.6 3.1c.4.7.7 1.4.9 2.2l3.3 1c.4.1.7.5.7 1zm1.6-23.6h-35c-.6 0-1-.4-1-1s.4-1 1-1h35c.6 0 1 .4 1 1s-.4 1-1 1z"
                    />
                  </g>
                </svg>

                <span className="sidebar-names">Project 002</span>
              </Link>
            </li>
            <li>
              <Link
                to="/project03"
                className={isActiveProject03 ? "nav_list  active" : "nav_list"}
              >
                <svg
                  id="Layer_1"
                  enable-background="new 0 0 66 66"
                  viewBox="0 0 66 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="XMLID_731_">
                    <path
                      id="XMLID_749_"
                      d="m33 35c-4.6 0-8.3 3.7-8.3 8.3s3.7 8.3 8.3 8.3 8.3-3.7 8.3-8.3-3.7-8.3-8.3-8.3z"
                    />
                    <path
                      id="XMLID_750_"
                      d="m47.7 14.7h9l-13.1-13.1v9c0 2.3 1.9 4.1 4.1 4.1z"
                    />
                    <path
                      id="XMLID_753_"
                      d="m47.7 16.7c-3.4 0-6.1-2.7-6.1-6.1v-9.6h-29c-2.2 0-3.9 1.8-3.9 3.9v56.2c0 2.2 1.8 3.9 3.9 3.9h40.8c2.2 0 3.9-1.8 3.9-3.9v-44.4zm-32.2-5.5h15.9c.6 0 1 .4 1 1s-.4 1-1 1h-15.9c-.6 0-1-.4-1-1s.4-1 1-1zm33.4 33.8c0 .4-.3.8-.7 1l-3.3 1c-.2.7-.5 1.4-.9 2.2l1.6 3.1c.2.4.1.9-.2 1.2l-2.4 2.2c-.3.3-.8.4-1.2.2l-3.1-1.6c-.7.4-1.4.7-2.2.9l-1 3.3c-.1.4-.5.7-1 .7h-3.3c-.4 0-.8-.3-1-.7l-1-3.3c-.8-.2-1.5-.5-2.2-.9l-3.1 1.6c-.4.2-.9.1-1.2-.2l-2.4-2.4c-.3-.3-.4-.8-.2-1.2l1.6-3c-.4-.7-.7-1.4-.9-2.2l-3.3-1c-.4-.1-.7-.5-.7-1v-3.3c0-.4.3-.8.7-1l3.3-1c.2-.7.5-1.5.9-2.2l-1.6-3c-.2-.4-.1-.9.2-1.2l2.4-2.4c.3-.3.8-.4 1.2-.2l3.1 1.6c.7-.4 1.4-.7 2.2-.9l1-3.3c.1-.4.5-.7 1-.7h3.3c.4 0 .8.3 1 .7l1 3.3c.8.2 1.5.5 2.2.9l3.1-1.6c.4-.2.9-.1 1.2.2l2.4 2.4c.3.3.4.8.2 1.2l-1.6 3.1c.4.7.7 1.4.9 2.2l3.3 1c.4.1.7.5.7 1zm1.6-23.6h-35c-.6 0-1-.4-1-1s.4-1 1-1h35c.6 0 1 .4 1 1s-.4 1-1 1z"
                    />
                  </g>
                </svg>

                <span className="sidebar-names">Project 003</span>
              </Link>
            </li>
          </ul>
          <span>
            <ul>
              <li>
                <Link to="/" className={"nav_list"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                  >
                    <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
                  </svg>
                  <span className="sidebar-names" style={{ fontSize: "18px" }}>
                    Back
                  </span>
                </Link>
              </li>
            </ul>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProjectSidebar;
